import axios from 'axios';
import config from '../appconfig/config.json';

const getOtpApiUrl = () => {
    let optUrl= '';
    switch (config.SERVER_STATUS) {
        case "DEV": optUrl = config.OtpApi.DEV
        break;
        case "SIT": optUrl = config.OtpApi.SIT 
        break;
        case "UAT": optUrl = config.OtpApi.UAT 
        break;
        case "PROD": optUrl = config.OtpApi.PROD 
        break;
        case "SIM": optUrl = config.OtpApi.SIM 
        break;
        default:
        break;
    }
    return optUrl;
}

const  OTPGeneration = (mobileNum,accessId,countryCode,legalID,authToken) => {  

    let baseUrl = getOtpApiUrl();
    let url = baseUrl+"/api/v1/OTP/OTPGeneration/"+mobileNum+"/"+ accessId +"/"+countryCode+"/"+legalID;
    let headerParams = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization':"Maybank" + " " + authToken
        }
    }
    let params =null;
    return axios.post(url,params,headerParams);
};

const  OTPVerification= (mobileNum,otp,accessId,countryCode,legalID,authToken) => { 

    let baseUrl = getOtpApiUrl();
    let url = baseUrl+"/api/v1/OTP/OTPVerification/"+ mobileNum +"/"+otp+"/"+ accessId +"/"+countryCode+"/"+legalID;
    let headerParams = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization':"Maybank" + " " +authToken
        }
    }
    let params =null;
    return axios.post(url,params,headerParams);
};

const OTPSecurity = () => {
 
    let params = { appId : "myinfopackageIW7cL4iFE5kf"};
    const headers = {
        'Content-Type': 'application/json'
    }
    let url = getOtpApiUrl()+'/api/Security'
    return axios.post(url, params, headers);
}

export default {
    OTPVerification,
    OTPGeneration,
    OTPSecurity
}